<template>
<div class="chapter">
<div class="inner_page">
<a id="page_i"></a>
<p class="half">KING JAMES VI &amp; I</p>
<p class="halfa">THE KING WHO UNITED SCOTLAND AND ENGLAND</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// Halftitle.vue?162b3ca8